import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectViewModel, WithKey } from 'src/app/domain/presenter/viewmodel/input.view.model';

@Component({
  selector: 'app-select',
  imports: [CommonModule, FormsModule],
  templateUrl: './select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent<T> implements ControlValueAccessor {
  @Input() viewModel?: SelectViewModel<T>;
  @Input() options: { label: string; value: any }[] = [];
  @Input() label?: string;
  @Output() didChange = new EventEmitter<WithKey>();

  id = '' + Math.random();
  value: any;

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  modelChange(event: Event) {
    const raw = (event.target as HTMLSelectElement).value;

    if (this.viewModel) {
      this.viewModel.value = (this.viewModel.options.find(x => String(x.value) === raw) ?? this.viewModel.options[0]).value;
      this.didChange.emit(this.viewModel);
    } else {
      const found = this.options.find(x => String(x.value) === raw);
      const value = found ? found.value : raw;
      this.value = value;
      this.onChange(value);
      this.onTouched();
    }
  }

  get currentOptions() {
    return this.viewModel ? this.viewModel.options : this.options;
  }

  get currentValue() {
    return this.viewModel ? this.viewModel.value : this.value;
  }
}
